import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import {withRouter} from 'react-router-dom';

import {ALVA_SELECTED_ORGANIZATION_KEY, ALVA_TOKEN_KEY} from 'services/auth/constants';
import {ResetPasswordWrapper} from './components/ResetPasswordWrapper';
import ValidateResetPasswordToken from './pages/ValidateResetPasswordToken';
import SetNewPassword from './pages/SetNewPassword';
import {WithChangeLocale} from '../../containers/LanguageProvider/WithChangeLocale';
import {WithValidateResetPasswordToken} from '../../api/users/WithValidateResetPasswordToken';
import {FormattedMessage} from 'react-intl';
import messages from './messages';


const SUCCESS_REDIRECT = '/login';

class ResetPasswordContainer extends React.Component {

    static propTypes = {
        location: PropTypes.shape({
            search: PropTypes.string
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func
        }).isRequired,
        displayToast: PropTypes.func
    };

    constructor(props) {
        super(props);

        const params = queryString.parse(this.props.location.search);

        this.state = {
            token: params['t'],
            tokenValidated: false,
            newPasswordSet: false,
            userData: null
        };
    }

    componentDidMount() {
        localStorage.removeItem(ALVA_SELECTED_ORGANIZATION_KEY);
    }

    onNewPasswordSet = () => {
        this.setState({newPasswordSet: true});
    };

    renderSetNewPassword = () => {
        return (
            <SetNewPassword onNewPasswordSet={this.onNewPasswordSet}/>
        );
    };

    onTokenValidated = (client, localLocale, changeLocale, userData) => {
        localStorage.setItem(ALVA_TOKEN_KEY, userData.authToken);
        client.cache.reset().then(() => {
            if (userData.language !== localLocale) {
                changeLocale(userData.language);
            }
            this.setState({tokenValidated: true, userData});
        });
    };

    renderValidateToken = () => {
        return (
            <WithChangeLocale>
                {({locale, changeLocale}) => (
                    <WithValidateResetPasswordToken>
                        {({validateResetPasswordToken, loading, error, client}) => (
                            <ValidateResetPasswordToken
                                validateToken={validateResetPasswordToken}
                                loading={loading}
                                error={error}
                                onValidToken={userData => this.onTokenValidated(client, locale, changeLocale, userData)}
                                token={this.state.token}
                            />
                        )}
                    </WithValidateResetPasswordToken>
                )}
            </WithChangeLocale>
        );
    };

    renderContent = () => {
        if (this.state.newPasswordSet) {
            window.setTimeout(() => {
                this.props.history.push(SUCCESS_REDIRECT);
            }, 1500);
            return <FormattedMessage {...messages.success}/>;
        }

        if (!this.state.tokenValidated) {
            return this.renderValidateToken();
        }

        if (!this.state.newPasswordSet) {
            return this.renderSetNewPassword();
        }

        return <p> Unknown Error </p>;
    };

    render() {
        return (
            <ResetPasswordWrapper>
                {this.renderContent()}
            </ResetPasswordWrapper>
        );
    }
}


export default withRouter(ResetPasswordContainer);
